exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn.active[data-v-182b3901] {\n  background: #0090da !important ;\n}\n.sticky-bar[data-v-182b3901] {\n  position: sticky;\n  top: 60px;\n  z-index: 100;\n  background: white;\n  padding: 20px 20px 1px 20px;\n}\n", ""]);

// exports
